import { Header, List, Pagination, Tabs } from '@piwikpro/ui-components';
import { useEffect, useState } from 'react';
import { useAppSelector } from '../hooks';
import {
  selectIncidentsByComponent,
  selectPastIncidents,
} from '../incidentSlice';
import { Incident } from '../model';
import { IncidentDetails } from './IncidentDetails';

import './PastIncidents.css';

const PastIncidentsList: React.FC = () => {
  const incidents = useAppSelector(selectPastIncidents);
  const [limit, setLimit] = useState(10);
  const [startIndex, setStartIndex] = useState(0);
  const [endIndex, setEndIndex] = useState(10);

  const incidentsByComponent = useAppSelector(selectIncidentsByComponent);
  const components = [...incidentsByComponent.keys()];

  const tabs = components.map((c, idx) => {
    return { id: idx, label: c, value: c };
  });

  function filterByComponent(
    incidents: Incident[],
    component: string
  ): Incident[] {
    return incidents.filter((incident) =>
      incident.affected
        .filter((ac) => ac.severity !== 'ok')
        .map((ac) => ac.name)
        .includes(activeTab)
    );
  }

  const activeTabName = tabs[0]?.value ?? '';
  const [activeTab, setActiveTab] = useState(activeTabName);
  useEffect(() => {
    if (activeTab === '') setActiveTab(tabs[0]?.value ?? '');
    // this useEffect is a workaround for react not noticing incidentsByComponent
    // changes. including tabs or activeTab dependency here would cause circular
    // dependencies.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [incidentsByComponent]);

  return (
    <>
      <div className="pastIncidents">
        <Header type="large">Past Incidents</Header>
        <Tabs
          active={activeTab}
          tabs={tabs}
          setActive={(val: string) => {
            setStartIndex(0);
            setEndIndex(limit);
            setActiveTab(val);
          }}
          RouterLink={null}
        />
        <List
          className="lista"
          emptyListText="No items"
          columns={[{ align: 'left', name: 'Incident', size: 1 }]}
        >
          {filterByComponent(incidents, activeTab)
            .slice(startIndex, endIndex)
            .map((incident) => (
              <IncidentDetails
                incident={new Incident(incident)}
                component={activeTab}
                key={`past-${incident.id}`}
              />
            ))}
        </List>
        <Pagination
          appearance={'compact'}
          framed={false}
          startIndex={startIndex}
          endIndex={endIndex}
          limit={limit}
          limitOptions={[10, 25, 50]}
          showLimitLabel
          total={filterByComponent(incidents, activeTab).length}
          onPageChange={function onPageChange(min: unknown, max: unknown) {
            setStartIndex(Number(min));
            setEndIndex(Number(max));
          }}
          onLimitChange={function onLimitChange(newLimit: unknown) {
            const newStartIndex =
              Math.floor(startIndex / Number(newLimit)) * Number(newLimit);
            setStartIndex(newStartIndex);
            setLimit(Number(newLimit));
            setEndIndex(newStartIndex + Number(newLimit));
          }}
        />
      </div>
    </>
  );
};

export { PastIncidentsList };
